import { Flex, Heading, Link, Text } from '@chakra-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';
import useWindowWidth from '../../hooks/useWindowSize';

const CleaningAccordionContainer = styled.div`
  width: 90%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const LearnMore = styled(Link)<{ href: string; children: React.ReactNode }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  font-family: Poppins, sans-serif;
  color: #253ec6 !important;
  &:hover {
    gap: 16px;
  }
  transition: gap 0.2s ease-in-out;
`;

const imageURLs = {
  standard_cleaning: require('../../assets/location_services.png'),
  special_mission: require('../../assets/special_mission_demo.png'),
  super_clean: require('../../assets/super_clean_demo.png'),
  move: require('../../assets/moving_demo.png'),
};

function CleaningTypes() {
  const { width } = useWindowWidth();

  const [openedCleaning, setOpenedCleaning] = useState<string | null>(
    'standard_cleaning'
  );

  function toggleCleaning(name) {
    setOpenedCleaning((prev) => (prev === name ? null : name));
  }

  const image = openedCleaning
    ? imageURLs[openedCleaning]
    : imageURLs['standard_cleaning'];

  return (
    <section className="how_it_works container">
      <h2 className="headline-2 center w-100" style={{ marginBottom: '96px' }}>
        <Text
          textTransform={'uppercase'}
          className="center w-100"
          fontSize={16}
          fontWeight={'normal'}
        >
          OUR SERVICES
        </Text>
        We've got a clean for every type of mess.
      </h2>
      <div
        className="row"
        style={{ alignItems: 'center', gap: width < 768 ? 32 : 'auto' }}
      >
        <div className="col-xs-12 col-md-6">
          <Cleanings
            toggleCleaning={toggleCleaning}
            openedCleaning={openedCleaning}
          />
        </div>
        <div className="col-xs-12 col-md-6">
          <img
            src={image}
            alt="Cleaning Types"
            style={{
              width: '100%',
              height: '100%',
              aspectRatio: '1',
              objectFit: 'contain',
              borderRadius: 32,
            }}
          />
        </div>
      </div>
    </section>
  );
}

function Cleanings({ openedCleaning, toggleCleaning }) {
  return (
    <CleaningAccordionContainer>
      <CleaningAccordion
        title={'Standard Cleaning'}
        desc={
          'Our basic clean. We cover all Checklist items. Extras optional. Best for those who clean regularly.'
        }
        name="standard_cleaning"
        isOpen={openedCleaning === 'standard_cleaning'}
        toggleCleaning={toggleCleaning}
      />
      <hr />
      <CleaningAccordion
        title={'Special Mission'}
        desc={
          "Our most popular. We cover all Checklist items with more time. Best for those who haven't cleaned in a while."
        }
        name="special_mission"
        isOpen={openedCleaning === 'special_mission'}
        toggleCleaning={toggleCleaning}
      />
      <hr />
      <CleaningAccordion
        title="Super Clean"
        desc="We've got work to do. We cover all Checklist items plus our extras. Best for those who rarely clean."
        name="super_clean"
        isOpen={openedCleaning === 'super_clean'}
        toggleCleaning={toggleCleaning}
      />
      <hr />
      <CleaningAccordion
        title="Moving In/Out Cleaning"
        desc="Moving in/out can be a hassle. We cover all Checklist items, plus our extras. Best for those who are moving in/out."
        name="move"
        isOpen={openedCleaning === 'move'}
        toggleCleaning={toggleCleaning}
      />
    </CleaningAccordionContainer>
  );
}

function CleaningAccordion({ name, title, desc, isOpen, toggleCleaning }) {
  return (
    <Flex direction={'column'} style={{ gap: 16 }} my="4">
      <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        onClick={() => toggleCleaning(name)}
        cursor="pointer"
      >
        <Flex style={{ gap: '16px' }}>
          <img src={require(`../../assets/icons/${name}.svg`)} alt={title} />
          <Heading size="md" fontWeight="semibold">
            {title}
          </Heading>
        </Flex>
        <img
          src={require('../../assets/icons/arrow_down_circle.svg').default}
          alt={isOpen ? 'Collapse' : 'Expand'}
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </Flex>
      {isOpen ? (
        <Flex direction="column" alignItems="flex-start" style={{ gap: 16 }}>
          <Text textAlign={'left'}>{desc}</Text>
          <LearnMore href={name === 'move' ? '/moving' : '/services'}>
            Learn More{' '}
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12L19 12"
                stroke="#253EC6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 5L19 12L12 19"
                stroke="#253EC6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </LearnMore>
        </Flex>
      ) : null}
    </Flex>
  );
}

export default CleaningTypes;
